import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

export const getTemplateById = (templateId: number, reportTemplateList: ReportTemplate[]) => {
    const template = reportTemplateList?.find((template) => template.id === templateId);
    return template || null;
};
